// 内容审核 - 客户端分页 composable
import { computed, ref, watch } from 'vue'

export function usePaged<T>(source: () => T[], defaultPageSize = 10) {
  const page = ref(1)
  const pageSize = ref(defaultPageSize)
  const total = computed(() => source().length)
  const pageCount = computed(() => Math.max(1, Math.ceil(total.value / pageSize.value)))
  const paged = computed(() => {
    const start = (page.value - 1) * pageSize.value
    return source().slice(start, start + pageSize.value)
  })

  function setPage(next: number) {
    const value = Number.isFinite(next) ? next : 1
    page.value = Math.min(Math.max(1, value), pageCount.value)
  }

  watch([total, pageSize], () => {
    if (page.value > pageCount.value) page.value = pageCount.value
  })

  return { page, pageSize, pageCount, total, paged, setPage }
}
